// Port of api/fuel/app/classes/insights/collection/designers.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Designer from 'offline/model/designer'
import GameDesigner from 'offline/model/game/designer'

export default Segment.extend({
    name: 'designers',
    requires: ['init'],
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        // set the limit
        var limit = detail ? 100 : 5

        var ranked = []

        var collectionIndex = this._data.base

        if (collectionIndex.length) {

            // get the sorted list of designers with most games owned
            var sorted = Util.queryFast('\
                SELECT \
                    COUNT(DISTINCT game_id) AS collected, \
                    designer_id AS designer \
                FROM \
                    game_designer \
                WHERE \
                    game_id IN (' + collectionIndex.join(',') + ') \
                    AND \
                    designer_id NOT IN(3) \
                GROUP BY \
                    designer_id \
                ORDER BY \
                    COUNT(DISTINCT game_id) DESC, \
                    designer_id ASC \
                LIMIT 0, ' + limit + ' \
            ')

            // get index of designers
            var index = Util.pluck(sorted, 'designer')

            // if we have results
            if (index.length) {

                // get all the games by the designers
                var applicableGames = GameDesigner.filter({
                    arrayed: true,
                    select: {
                        rename: {
                            'game_id': 'game',
                            'designer_id': 'designer'
                        }
                    },
                    where: [
                        ['designer_id', 'in', index],
                        ['game_id', 'in', collectionIndex]
                    ]
                })

                // get index of their games
                var applicableGameIndex = Util.pluck(applicableGames, 'game')

                // group games by designer
                var applicableGamesGrouped = {}

                for (var ai = 0; ai < applicableGames.length; ai++) {
                    var link = applicableGames[ai]

                    if (!applicableGamesGrouped[link.designer]) applicableGamesGrouped[link.designer] = []
                    applicableGamesGrouped[link.designer].push(parseInt(link.game, 10))
                }

                // get all ratings for the designer games
                var ratings = Util.queryFast('\
                    SELECT \
                        AVG(r.rating_value) AS rating, \
                        r.game_id AS game \
                    FROM \
                        rating r \
                    WHERE \
                        r.game_id IN (' + applicableGameIndex.join(',') + ') \
                        AND \
                        r.user_id IN (' + Util.in(userIndex) + ') \
                    GROUP BY \
                        r.game_id \
                ', null, 'game')

                // get all designers
                var details = Designer.where([
                    ['designer_id', 'in', index]
                ]).associated()

                // add each result to ranked list
                for (var si = 0; si < sorted.length; si++) {
                    var item = sorted[si]

                    var gameRatings = []

                    // for each designer game, check it's in the collection
                    var designerGames = applicableGamesGrouped[item.designer] || []
                    for (var gi = 0; gi < designerGames.length; gi++) {
                        var game_id = designerGames[gi]

                        gameRatings.push({
                            id: game_id,
                            rating: (ratings[game_id] && ratings[game_id].rating) ? parseFloat(ratings[game_id].rating) : '-'
                        })
                    }

                    gameRatings.sort(function(a, b) {
                        var ra = (a.rating === '-') ? -1 : a.rating, rb = (b.rating === '-') ? -1 : b.rating
                        return rb !== ra ? rb - ra : a.id - b.id
                    })

                    for (var ti = 0; ti < 3 && ti < gameRatings.length; ti++) {
                        this._references.games.push(gameRatings[ti].id)
                    }

                    ranked.push({
                        id: details[item.designer] ? details[item.designer].get_id() : item.designer,
                        name: details[item.designer] ? details[item.designer].get_name() : '',
                        count: parseInt(item.collected, 10),
                        games: gameRatings.slice(0, 3)
                    })
                }

            }

        }

        return {
            designers: ranked
        }

    }
})
